/**
 * 連携機能使用有無のラジオボタンのエリアを表示非表示
 * @param select string
 */
window.switchingWithConnectionArea = function (select = 'customer') {
    let with_connection_area = $('.with_connection_area');
    if (!$('.input-' + select + '-select option:selected').data('has-connection')) {
        // 連携機能を使用しないにチェック
        $('#with_connection_0').prop('checked', true);
        with_connection_area.hide();
        with_connection_area.prop('disabled', true);

        return false;
    }
    // 連携機能を使用するにチェック
    $('#with_connection_1').prop('checked', true);
    with_connection_area.show();
    with_connection_area.prop('disabled', false);
}

/**
 * 連携機能使用有無のラジオボタンのエリアを表示非表示-一覧画面ver.
 * @param is_connection string
 */
window.switchingWithConnectionAreaFromIndex = function (is_connection) {
    let with_connection_area = $('.with_connection_area');
    if (!is_connection) {
        // 連携機能を使用しないにチェック
        $('#with_connection_0').prop('checked', true);
        with_connection_area.hide();
        with_connection_area.prop('disabled', true);

        return false;
    }
    // 連携機能を使用するにチェック
    $('#with_connection_1').prop('checked', true);
    with_connection_area.show();
    with_connection_area.prop('disabled', false);
}

/**
 * 連携機能使用有無のラジオボタン変更時にhidden項目を書き換え
 */
window.changeWithConnection = function () {
    $("input[name='with_connection']").val($("input[name='with_connection_radio']:checked").val());
}

/**
 * copy_order_idの書き換え
 */
window.updateCopyOrderId = function (copy_order_id) {
    // 書換処理
    $('#copy_order_id').val(copy_order_id);
}
